export default __webpack_public_path__ + "static/media/19.73d8dc6d.mp3";